import { Log } from 'ng2-logger';
import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import Translator from '../../../../../core/i18n';
import { IAction, IAppState } from '../../../../../models/action/core';
import { Formik, FormikActions, FormikProps } from 'formik';
import Input from '../../../../../components/input/text/input-formik';
import { Notification } from '../../../../../components/notification/main';
import Switch from 'react-switch';
import { Common } from '../../../../../core/common';
import * as Actions from '../../../../../store/actions/examSession';
import { IExamSessionData, IExamSessionList } from '../../../../../models/action/examSession';
import Moment from 'moment';
import { IPreference } from '../../../../../models/action/profile';

const T = Translator.create();
const _logger = Log.create('add security');

let _common: Common;

interface IAddSecurityModalProps {
    currentTab: string;
    coursePageActivityId?: string;
    coursePageClassId?: string;
    examId?: string;
    examSessionId: string;
    updateActivityId?: string;
    dispatch?: any;
    examSessionData?: IExamSessionData;
    userPreferences?: IPreference[];
    sessionList?: any;
    setExamSessionId: (examSessionId: string) => void;
}

interface ISecurityModalState {
    accessPassphrase: string;
    showPassword: boolean;
}

export class AddSecurityModal extends Component<IAddSecurityModalProps, ISecurityModalState> {
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
            accessPassphrase: '',
            showPassword: false
        };
    }

    getExamSessionList = (examSessionId: string) => {
        if (this.props.coursePageActivityId && this.props.coursePageClassId && this.props.updateActivityId) {
            this.props.dispatch(
                Actions.ExamSessionListGetAction(
                    this.props.updateActivityId,
                    this.props.coursePageActivityId,
                    this.props.coursePageClassId,
                    '',
                    'get',
                    examSessionId
                )
            );
        }
    };

    callBackFunction = (values: any) => {
        if (values) {
            this.getExamSessionList(values);
            this.props.setExamSessionId(values);
            if (this.props.examSessionId && this.props.examId) {
                this.props.dispatch(Actions.ExamSessionPublishDatas(this.props.examId, this.props.examSessionId, '', 'get'));
            }
        }
    };

    saveSecurity = (model: any, FormActions: FormikActions<any>) => {
        this.initSubmitValuesForApi(model);
        this.props.dispatch(Actions.ExamSessionAddAction(model, '', 'get', this.callBackFunction));
        FormActions.setSubmitting(false);
    };

    initSubmitValuesForApi(values: any) {
        const _formattedExamSessionBeginDate =
            values.examSessionBeginDate && values.examSessionBeginDateTime
                ? Moment(
                    values.examSessionBeginDate,
                    _common.findDateFormat(this.props.userPreferences) + ' ' + values.examSessionBeginDateTime,
                    window.appSettings.DefaultDateTimeFormat
                )
                : '';
        values.examSessionBeginDateForApi = _formattedExamSessionBeginDate
            ? Moment(_formattedExamSessionBeginDate)
                .set({
                    h: Moment(values.examSessionBeginDateTime, window.appSettings.DefaultDateTimeFormat).get('hour'),
                    m: Moment(values.examSessionBeginDateTime, window.appSettings.DefaultDateTimeFormat).get('minute')
                })
                .format(window.appSettings.DefaultDateFormatApi)
            : '';

        const _formattedExamSessionEndDate =
            values.examSessionEndDate && values.examSessionEndDateTime
                ? Moment(
                    values.examSessionEndDate,
                    _common.findDateFormat(this.props.userPreferences) + ' ' + values.examSessionEndDateTime,
                    window.appSettings.DefaultDateTimeFormat
                )
                : '';
        values.examSessionEndDateForApi = _formattedExamSessionEndDate
            ? Moment(_formattedExamSessionEndDate)
                .set({
                    h: Moment(values.examSessionEndDateTime, window.appSettings.DefaultDateTimeFormat).get('hour'),
                    m: Moment(values.examSessionEndDateTime, window.appSettings.DefaultDateTimeFormat).get('minute')
                })
                .format(window.appSettings.DefaultDateFormatApi)
            : '';
    }

    public render() {
        const userDateFormat: string = _common.findDateFormat(this.props.userPreferences!);
        const initialFormValues: any = {
            ...this.props.examSessionData!,
            dateFormat: userDateFormat,
            accessPassphrase: this.props.sessionList && this.props.sessionList[0].accessPassphrase != null && this.props.sessionList[0].accessPassphrase != undefined ? this.props.sessionList[0].accessPassphrase : '',
            examSessionEndDate:
                this.props.examSessionData && this.props.examSessionData.examSessionEndDate
                    ? Moment(this.props.examSessionData.examSessionEndDate.toString())
                        .format(userDateFormat)
                        .toString()
                    : '',
            examSessionEndDateTime:
                this.props.examSessionData && this.props.examSessionData.examSessionEndDate
                    ? Moment(this.props.examSessionData.examSessionEndDate.toString())
                        .format(window.appSettings.DefaultDateTimeFormat)
                        .toString()
                    : '',
            examSessionBeginDate:
                this.props.examSessionData && this.props.examSessionData.examSessionBeginDate
                    ? Moment(this.props.examSessionData.examSessionBeginDate.toString())
                        .format(userDateFormat)
                        .toString()
                    : '',
            examSessionBeginDateTime:
                this.props.examSessionData && this.props.examSessionData.examSessionBeginDate
                    ? Moment(this.props.examSessionData.examSessionBeginDate.toString())
                        .format(window.appSettings.DefaultDateTimeFormat)
                        .toString()
                    : '',
            examId: this.props.updateActivityId ? this.props.updateActivityId : '',
            examSessionId: this.props.examSessionData ? this.props.examSessionData.examSessionId : '',
        };

        return (
            <div
                className={'tab-pane fade' + (this.props.currentTab === '_sessionAddSecurity' ? ' show active' : '')}
                style={{ width: '100%' }}
                role="tabpanel"
                aria-labelledby="security-tab"
            >
                <div className="container">
                    <Formik
                        enableReinitialize={true}
                        initialValues={initialFormValues}
                        onSubmit={(values, actions) => {
                            this.saveSecurity(values, actions);
                        }}
                    >
                        {(props: FormikProps<any>) => {
                            const { values, handleChange, handleBlur, handleSubmit } = props;
                            return (
                                <div className="filter-fields mt-4">
                                    <form onSubmit={props.handleSubmit} key={'project_add_user_modal'} noValidate={true}>
                                        <div className="row align-items-baseline">
                                            <div className="col-12">
                                                <div className="form-input form-group with-icon">
                                                    <input
                                                        name="accessPassphrase"
                                                        id="accessPassphrase"
                                                        type={values.showPassword ? 'text' : 'password'}
                                                        value={values.accessPassphrase}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        required
                                                    />
                                                    <span className="highlight" />
                                                    <span className="bar" />
                                                    <label htmlFor="accessPassphrase">{T.t('r_password')}</label>
                                                </div>
                                                <div className="mt-3">
                                                    <label>{T.t('r_show_password')}</label>
                                                    <Switch
                                                        id="show_password"
                                                        className="react-switch ml-2"
                                                        onChange={(checked: boolean) => {
                                                            values.showPassword = checked;
                                                            this.setState(this.state);
                                                        }}
                                                        checked={values.showPassword}
                                                        defaultChecked={false}
                                                        onColor="#86d3ff"
                                                        onHandleColor="#28a745"
                                                        handleDiameter={18}
                                                        uncheckedIcon={false}
                                                        checkedIcon={false}
                                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                        height={20}
                                                        width={38}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col text-right" style={{ paddingBottom: 10 }}>
                                                <button id='button_save' type="button" className="btn btn-green" onClick={() => props.handleSubmit()}>
                                                    <i className="material-icons mr-2">save</i> {T.t('r_save_button')}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            );
                        }}
                    </Formik>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IAddSecurityModalProps): IAddSecurityModalProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IAddSecurityModalProps = Object.assign({}, ownProps, {
        userPreferences: state.profile.userPreferences.preferences,
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        examSessionData: state.examSession.examSessionData,
        coursePageclassInformation: state.coursePage.coursePageclassInformation,
        courseContentTermWeeks: state.coursePage.courseContentTermWeeks,
        sessionList: state.examSession.sessionList
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return (
        next.examSession.examSessionData === prev.examSession.examSessionData &&
        next.profile.userPreferences === prev.profile.userPreferences &&
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.coursePage.coursePageclassInformation === prev.coursePage.coursePageclassInformation &&
        next.coursePage.courseContentTermWeeks === prev.coursePage.courseContentTermWeeks &&
        next.examSession.sessionList === prev.examSession.sessionList
    );
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CAddSecurityModal = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(AddSecurityModal);

export default CAddSecurityModal;
